module.exports = __webpack_public_path__ + "img/icon-sport-active.056111c.webp";